/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

export const AdminPlanStorageClassGet = {
  id: 'admin-plan-storage-class.get',
  tag: 'Admin',
  summary: 'Plan storage class administration',
  description: 'Get all Storage classes',
  method: 'get',
  flags: { isAuthorized: true, isSuperuser: true },
  route: () => `/administration/plan/storage-class`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(
            z.strictObject({
              id: z.string(),
              isDefault: z.boolean(),
            }),
          ),
        },
      },
    },
  },
} as const satisfies Endpoint;
